import React, { PureComponent } from 'react';
import { eapiClient } from '../../../../../restClient';
import { Translations, throttle } from '../../../../../utils';
import DropdownContainer from '../../../../common/Dropdown/DropDown';
import InputTextbox from '../../../../common/InputBox/inputTextbox';
import MultiLineSelect from '../../../../common/MultiLineSelect';
import { getAggregateFormComponents } from '../../../CustomerDetails/CaptureAccountDetails';
import "./index.css";

class CashConBilling extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            billingAccount: this.props.billingDetails,
            billingUnitBasis: [],
            billingFeeType: [],
            billingProduct: []
        }
    }

    componentWillMount() {
        eapiClient('/sows/taxonomies/urn:hsbc:cmb:gdocs:sows:taxonomies:billingUnitBasis')
            .then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        billingUnitBasis: data.responseData.classificationNodes,
                    })
                }
            })
        eapiClient('/sows/taxonomies/urn:hsbc:cmb:gdocs:sows:taxonomies:billingFeeType')
            .then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        billingFeeType: data.responseData.classificationNodes,
                    })
                }
            })
        eapiClient('/sows/taxonomies/urn:hsbc:cmb:gdocs:sows:taxonomies:billingProduct')
            .then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        billingProduct: data.responseData.classificationNodes,
                    })
                }
            })
    }

    componentWillReceiveProps(nextProps) {
        if (((JSON.stringify(this.props.billingDetails) !== JSON.stringify(nextProps.billingDetails)) ||
            JSON.stringify(this.state.billingAccount) !== JSON.stringify(nextProps.billingDetails))) {
            if (nextProps.billingDetails.length) {
                this.setState({
                    billingAccount: nextProps.billingDetails
                })
            }
        }
    }

    getTranslation = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    renderAggregatecomponent = (formJson, billingAccountIndex, billingItemObject) => {
        const { components, name: formName, addItemButton } = formJson || {}

        const componentList = getAggregateFormComponents(components, this.props.lang.currentLang.lang, this.props.lang.translatedData)

        const key = "billing"
        const idPrefix = ""

        const handleFormChange = (value, name, formName, formIndex) => {
            const newFormData = this.props.billingDetails[billingAccountIndex]
            if (formName && newFormData) {
                if (newFormData[formName] && newFormData[formName][formIndex]) {
                    newFormData[formName][formIndex][name] = value
                } else {
                    newFormData[formName] = [{ [name]: value }]
                }
                this.props.handleBillingFormChange({ ...this.props.billingDetails[billingAccountIndex], [formName]: newFormData[formName] }, billingAccountIndex)
            }
        }

        const handleAddProductFee = (formName) => {
            const newFormData = this.props.billingDetails[billingAccountIndex]
            if (formName && newFormData) {
                if (newFormData && newFormData[formName] && newFormData[formName].length) {
                    newFormData[formName] = [...newFormData[formName], { ...billingItemObject }]
                }
                else {
                    newFormData[formName] = [...productFees, { ...billingItemObject }]
                }
                this.props.handleBillingFormChange({ ...this.props.billingDetails[billingAccountIndex], [formName]: newFormData[formName] }, billingAccountIndex)
            }
        }

        const handleDeleteBillingItem = (formName, formIndex) => {
            const formData = this.props.billingDetails[billingAccountIndex]
            if (formIndex > -1 && formData && formData[formName] && formData[formName][formIndex]) {
                this.props.handleBillingFormChange({
                    ...formData, [formName]:
                        formData[formName].filter((el, elIndex) => elIndex !== formIndex)
                }, billingAccountIndex)
            }
        }
        const getOptiondata = name => {
            if (name === "products") {
                return this.state.billingProduct && this.state.billingProduct.length ? this.state.billingProduct.map(option => ({ ...option, value: option.id })) : []
            }
            else if (name === 'chargeType') {
                return this.state.billingFeeType ? this.state.billingFeeType.map(option => ({ ...option, value: option.name })) : []
            }
            else {
                return this.state.billingUnitBasis ? this.state.billingUnitBasis.map(option => ({ ...option, value: option.name })) : []
            }
        }

        const productFees = (this.props.billingDetails && this.props.billingDetails[billingAccountIndex] &&
            this.props.billingDetails[billingAccountIndex][formName] &&
            this.props.billingDetails[billingAccountIndex][formName]) || [{ ...billingItemObject }]

        const componentJsx = (formData, formIndex) => componentList.map((component, componentIndex) => {
            const { fieldType = '', name = '', type = '', label = '', apiUrl = '', title = '', header = '', mandatory = "", mandatoryMessage, maxChars } = component
            switch (fieldType) {
                case "inputField":
                    return (
                        <section className="form-row-container" key={key + "-in" + componentIndex}>
                            <section className="form-row-label">
                                <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                                    {this.getTranslation(label)}
                                </label>
                            </section>
                            <section className="form-row-field">
                                <InputTextbox
                                    name={`${formName}_${formIndex}_${name}_${componentIndex}`}
                                    id={`${idPrefix}${formName}_${formIndex}_${name}_${componentIndex}`}
                                    setInputvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                                    type={type}
                                    _value={formData[name] || ''}
                                    mandatory={mandatory}
                                    mandatoryMessage={this.getTranslation(mandatoryMessage)}
                                    setFieldValidtionState={(field, isValid) => {
                                        // handleFormValidation(field, isValid)
                                    }}
                                    disabled={this.props.isReadOnly && this.props.isReadOnly()}
                                    max={maxChars}
                                ></InputTextbox>
                            </section>
                        </section>
                    )
                case "formTitle":
                    return (
                        <article className='header-wrapper'>
                            <section key={key + "-tt" + componentIndex}>
                                <section>
                                    <h5><strong>{`${this.getTranslation(title)} ${formIndex + 1}`}</strong></h5>
                                </section>
                            </section>
                            <span>{"All fields are required unless marked as 'optional'"}</span>
                            <section>
                                {deleteIconJsx(formIndex)}
                            </section>
                        </article>
                    )
                case 'dropDownSelect':
                    {
                        const type = 'sowFee_Type'
                        const options = [{ name: "Product Subscription Fee", value: "productSubscriptionFee", id: '1' }, { name: "Sweep Transfer Fee", value: "sweepTransferFee", id: '2' }]
                        return (
                            <React.Fragment>
                                <section className="form-row-container" key={key + "-dd" + componentIndex}>
                                    <section className="form-row-label">
                                        <label htmlFor={`${formName}_${formIndex}_${name}_${componentIndex}`}>
                                            {this.getTranslation(label)}
                                        </label>
                                    </section>
                                    <section className="form-row-field account-dropdown">
                                        <DropdownContainer
                                            ddname={`${formName}_${formIndex}_${name}_${componentIndex}`}
                                            id={`${idPrefix}${formName}_${formIndex}_${name}_${componentIndex}`}
                                            setDropdownvalue={(value) => { handleFormChange(value, name, formName, formIndex) }}
                                            value={(formData[name] && formData[name]["value"]) || ''}
                                            type={type}
                                            taxonomies={getOptiondata(name)}
                                            properties={{ editType: "gls-sow-billing-account" }}
                                            formData={formData}
                                            mandatory={mandatory}
                                            mandatoryMessage={this.getTranslation(mandatoryMessage)}
                                            setFieldValidtionState={(field, isValid) => {
                                            }}
                                            disabled={this.props.isReadOnly && this.props.isReadOnly()}
                                        />
                                    </section>
                                </section>
                            </React.Fragment>
                        )
                    }
                default:
                    break;
            }
        }
        )

        const deleteIconJsx = (formIndex) => formIndex > 0 ?
            <section
                className="delete-icon"
                id={formName + "_" + formIndex}
            >
                <button
                    className="gdocs-btn-icon"
                    aria-label="Delete Product Fee"
                    onClick={() => { handleDeleteBillingItem(formName, formIndex) }}
                    disabled={this.props.isReadOnly && this.props.isReadOnly()}
                >
                    <i className='icon icon-bin'></i>
                </button>
            </section> : null

        const addProductFeeJsx = (formName, label = "Add Rows") => {
            return 1 ?
                <section className='gdocs-mt-0p5'>
                    <button className="gdocs-btn-default" id={"add-" + formName + productFees.length + 1} onClick={(e) => { e.preventDefault(); handleAddProductFee(formName) }} disabled={this.props.isReadOnly && this.props.isReadOnly()}>
                        <span className="icon icon-add addicon">
                        </span>{`${this.getTranslation(label)} ${productFees.length + 1}`}
                    </button>
                </section> : null
        }

        return (
            <article>
                <section className="ccr-rate-box__combo-box gdocs-border-top-none">
                    {productFees.map((billData, billIndex) => {
                        return componentJsx(billData, billIndex)
                    })}
                    {addProductFeeJsx(formName, addItemButton)}
                </section>
            </article>
        )
    }

    renderAccountDropDown = ({ name = "", title = "", addAccountLink = 'Add Account' } = {}, static_text_addOtherAccount, billingAccountIndex) => {
        return (
            <article className='sow-gls-tab-cash-con-billing'>
                <section className='sow-billing-note'>
                    {/* {static_text_addOtherAccount && static_text_addOtherAccount.para ? this.getTranslation(static_text_addOtherAccount.para) : null} */}
                    {this.deleteAccountJsx(billingAccountIndex)}
                </section>
                <section className='form-row-container account-id-dropdown'>
                    <section className='form-row-label'>
                        <label id={name + billingAccountIndex + '__label'}>
                            {`${this.getTranslation(title)} ${billingAccountIndex + 1}`}
                        </label>
                    </section>
                    <section>
                        <MultiLineSelect
                            id={name + billingAccountIndex}
                            defaultValue="Please select"
                            requiredFields={{
                                "row1": ["accountType", "accountNumber", "currency", "location"],
                                "row2": ["accountHolder"],
                                "row3": []
                            }}
                            data={this.props.accountList}
                            value={(this.props.billingDetails && this.props.billingDetails[billingAccountIndex] && this.props.billingDetails[billingAccountIndex].accountId) || ''}
                            disabledOptions={
                                (Array.isArray(this.props.accountList) && Array.isArray(this.props.billingDetails) &&
                                    this.props.accountList.map(acc => this.props.billingDetails.find(selectedAcc => selectedAcc.accountId === acc.id) &&
                                        this.props.billingDetails.find(selectedAcc => selectedAcc.accountId === acc.id).accountId).filter(el => el)) || []
                            }
                            _onChange={(data) => this.handleBillingAccountChange(data, billingAccountIndex)}
                            showEdit={false}
                            isDisable={this.props.isReadOnly && this.props.isReadOnly()}
                        >
                        </MultiLineSelect>
                    </section>

                </section>
                <section className='sow-billing-add-account-link'>
                    <button className='persist-link create-link' onClick={() => { this.props.setCurrentActiveTab(0) }}
                        disabled={this.props.isReadOnly && this.props.isReadOnly()}>
                        <i className="icon icon-add"></i>
                        {this.getTranslation(addAccountLink)}
                    </button>
                    <section className='gdocs-note-text'>
                        {static_text_addOtherAccount && static_text_addOtherAccount.para ? this.getTranslation(static_text_addOtherAccount.noteText) : null}
                    </section>
                </section>
            </article >

        )
    }

    handleBillingAccountChange = (data, accountBillingIndex) => {
        if (data.id && this.props.billingDetails && this.props.billingDetails[accountBillingIndex]) {
            this.props.handleBillingFormChange({ ...this.props.billingDetails[accountBillingIndex], accountId: data.id }, accountBillingIndex)
        }
    }

    addAccountJsx = (formName) => {
        return 1 ?
            <section className='gdocs-mt-0p5'>
                <button className="gdocs-btn-default" id={"add-" + formName + this.state.billingAccount.length + 1} onClick={(e) => { e.preventDefault(); this.handleAddAccount(formName) }} disabled={this.props.isReadOnly && this.props.isReadOnly()}>
                    <span className="icon icon-add addicon">
                    </span>Add account {this.state.billingAccount.length + 1}
                </button>
            </section> : null
    }

    handleAddAccount = () => {
        if (this.props.formJson && this.props.formJson.guideaggregateformbox_billingone && this.props.formJson.guideaggregateformbox_billingone.billingItemObject) {
            this.props.handleAddDelAccount([...this.state.billingAccount, { accountId: '', billing: [{ ...this.props.formJson.guideaggregateformbox_billingone.billingItemObject }] }])
        }
    }

    deleteAccountJsx = (billingAccountIndex) =>
        billingAccountIndex > 0 ?
            <section
                style={{ display: 'inline-block', float: 'right', cursor: 'pointer' }}
                className="delete-icon"
                id={'formName' + "_" + this.state.billingAccount.length}
                disabled={this.props.isReadOnly && this.props.isReadOnly()}
            >
                <i
                    className="icon icon-bin"
                    tabIndex="0"
                    role="button"
                    aria-label="Delete Billing Account"
                    onClick={() => { this.handleDeleteAccount(billingAccountIndex) }}
                    onKeyDown={(e) => { this.handleDeleteAccountOnEnter(e, billingAccountIndex) }}
                ></i>
            </section> : null

    handleDeleteAccount = (formIndex) => {
        this.props.handleAddDelAccount(this.state.billingAccount.filter((acc, accIndex) => accIndex !== formIndex))
    }

    handleDeleteAccountOnEnter = (event, formIndex) => {
        if (event.code === 'Enter' || event.keyCode === 13 || event.key === 'Enter' || event.code === 'Space' || event.keyCode === 32 || event.key === ' ') {
            event.preventDefault();
            this.handleDeleteAccount(formIndex);
        }
    }

    render() {
        const { guidedropdownlist_accountId, guideaggregateformbox_billingone = {}, static_text_addOtherAccount, } = this.props.formJson || {}

        return (
            <article className='cashcon-summ-billing-wrapper'>
                <section className='sow-billing-note'>
                    {static_text_addOtherAccount && static_text_addOtherAccount.para ? this.getTranslation(static_text_addOtherAccount.para) : null}
                </section>
                {
                    Array.isArray(this.state.billingAccount) && this.state.billingAccount.map((billingAccountData, billingAccountIndex) => {
                        return <React.Fragment key={billingAccountIndex}>
                            <article className='gdocs-mb-0p5'>
                                <section className='ccr-rate-box__combo-box gdocs-border-bottom-none'>
                                    {this.renderAccountDropDown(guidedropdownlist_accountId, static_text_addOtherAccount, billingAccountIndex)}
                                </section>
                                <section className='billing-aggregate-component'>
                                    {this.renderAggregatecomponent(guideaggregateformbox_billingone, billingAccountIndex, guideaggregateformbox_billingone.billingItemObject)}
                                </section>
                            </article>
                        </React.Fragment>

                    })
                }
                <section className="ccr-rate-box__combo-box">
                    {this.addAccountJsx('cashConBilling')}
                </section>
                <section className='btn-submit-container'>
                    <button className="gdocs-btn-submit" onClick={() => {
                        throttle(this.props.handleUpdateBilling, 3000)
                    }} disabled={this.props.isReadOnly && this.props.isReadOnly()}>Refresh</button>
                </section>
            </article >
        );
    }
}

export default CashConBilling;


// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/CashConcentrationSummary/CashConBilling/index.js